// eslint-disable-next-line import/no-unresolved
import io from 'socket.io-client';
import { SOCKET_END_POINT } from '../misc/config';

const Socket = io(SOCKET_END_POINT);

export const clearSocketConnection = () => {
  try {
    Socket.disconnect();
  } catch (e) {
    console.log(e);
  }
};

export default Socket;
